import React, {useEffect, useState} from 'react'
import {Button, Form, Input, InputNumber, Modal} from "antd";
import {getYuYueById, putkuandai} from "../../lib/api_yuyue";

const formItemLayout = {
    labelCol: {
        span: 6
    },
    wrapperCol: {
        span: 18
    },
};


const KuanDaiModal = ({id, visible, onOk, onCancel}) => {
    const [form] = Form.useForm();
    const [data, setData] = useState(null);

    const fetchData = () => {
        getYuYueById(id).then(res => {
            setData(res);
            // if (res.code === 0) {
            //     setData(res.data);
            // }
        });
    }

    useEffect(fetchData, []);
    const handleOk = () => {
        form.validateFields().then(values => {
            putkuandai({
                yuyue_id: id,
                kd_sp_no: values.kd_sp_no,
            }).then(res => {
                if (res.code === 0) {
                    onOk && onOk();
                }
            })
        })
    }
    return (
        <Modal
            title="关联款待审批单"
            open={visible}
            onOk={handleOk}
            onCancel={onCancel}
        >
            {data ? (
                <Form {...formItemLayout}
                      form={form}
                      initialValues={{
                          kd_sp_no: data.kd_sp_no,
                      }}
                >
                    <Form.Item name="kd_sp_no" label="审批编号">
                        <Input/>
                    </Form.Item>
                </Form>

            ) : (
                <div>
                    <div>加载中</div>
                </div>
            )}

        </Modal>
    )
}

export default KuanDaiModal;